import React from 'react';

import TableActions from 'components/Common/TableActions';
import { BANKS_COMMON } from './constants';

export const getColumns = ({ onEdit, onDeleteBank }) => [
  {
    title: BANKS_COMMON.id_title,
    dataIndex: BANKS_COMMON.id,
  },
  {
    title: BANKS_COMMON.name_title,
    dataIndex: BANKS_COMMON.name,
  },
  {
    title: ' ',
    dataIndex: BANKS_COMMON.actions,
    width: 50,
    align: 'center',
    render: (_, record) => (
      <TableActions
        onEdit={onEdit(record)}
        onDelete={onDeleteBank(record.id)}
      />
    ),
  },
];
